import { css } from "@emotion/react"
import { Section } from "../../../../packages/editing/Section"
import { Flex } from "../ui/components/base/Flex"
import { colors } from "../ui/constants/colors"
import { PressLogosCarousel } from "../ui/components/carousel/PressLogosCarousel"
import { Uuid, Image, Url, ImageToUrl } from "../../../../reactor"
import { responsiveCss } from "../ui/helpers/css"
import { TrustpilotWidget } from "../ui/components/other/TrustpilotWidget"

function TrustpilotAndPressLogos(section: {
    /**
     * Logos should scroll when Trustpilot and logos are stacked (ref. stack breakpoint).
     * @default false
     */
    logosShouldScrollWhenStacked: boolean

    /**
     * How fast the carousel scrolls. Given in pixels per second.
     *
     * @default 30
     */
    carouselSpeed: number

    logos: {
        readonly id: Uuid<"PressLogo">
        image: Image
        url?: Url
    }[]
}) {
    return (
        <div>
            <Flex
                justifyContent="space-between"
                style={{ gap: 20, overflow: "clip" }}
                css={css(
                    { marginTop: 20, marginBottom: 20 },
                    responsiveCss("max", "xs", {
                        flexDirection: "column",
                    }),
                    responsiveCss("min", "sm", { flexDirection: "row-reverse" }),
                    responsiveCss("min", "md", { marginTop: 24, marginBottom: 24 })
                )}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                    css={css({ flex: "0 0 auto" })}
                >
                    <div
                        css={css(
                            css({
                                display: "flex",
                                flex: "0 0 auto",
                                alignItems: "center",
                            }),
                            responsiveCss("max", "xs", {
                                width: "100%",
                                justifyContent: "center",
                            })
                        )}
                    >
                        <div css={responsiveCss("max", "xs", { display: "none" })}>
                            <TrustpilotWidget
                                widget="microStar"
                                style={{
                                    transform: "translateY(1px)",
                                    scale: "0.9",
                                }}
                            />
                        </div>
                        <div
                            css={css(
                                {
                                    "@media (max-width: 380px)": { scale: "0.72" },
                                    scale: "0.8",
                                    display: "flex",
                                    justifyContent: "center",
                                },
                                responsiveCss("min", "sm", { display: "none" })
                            )}
                        >
                            <TrustpilotWidget widget="microCombo" width={500} />
                        </div>
                    </div>
                </div>
                {section.logosShouldScrollWhenStacked ? (
                    <div
                        style={{ flex: "1 1 0", height: 24 }}
                        css={responsiveCss("min", "sm", { display: "none" })}
                    >
                        <PressLogosCarousel speed={section.carouselSpeed} logos={section.logos} />
                    </div>
                ) : null}
                <Flex
                    flex="1 1 0"
                    gap={40}
                    css={css(
                        responsiveCss("max", "xs", {
                            justifyContent: section.logos.length > 2 ? "space-between" : "center",
                            gap: section.logos.length > 2 ? 24 : undefined,
                            display: section.logosShouldScrollWhenStacked ? "none" : undefined,
                        }),
                        responsiveCss("min", "sm", { overflow: "hidden" }),
                        css({
                            flexWrap: "wrap",
                            color: colors.gray300,
                            height: 24,
                            justifyContent: "flex-start",
                        })
                    )}
                >
                    {section.logos.map((l) => (
                        <div
                            key={l.id.valueOf()}
                            style={{ display: "flex", alignItems: "center", height: "100%" }}
                        >
                            <img
                                src={ImageToUrl(l.image, { width: 300 })}
                                style={{ width: "auto", maxHeight: "100%" }}
                            />
                        </div>
                    ))}
                </Flex>
            </Flex>
        </div>
    )
}

Section("TrustpilotAndPressLogos", TrustpilotAndPressLogos)
